import * as React from 'react';
import { Link } from 'react-router-dom';
import NoRecords from './../Shared/NoRecords';
import Pagination from './../Shared/Pagination';

const ContentRow = (content: any, index: number) => {
  return (
    <tr key={index}>
      <td>{content.id}</td>
      <td>{content.name}</td>
      <td>
        <Link className="btn btn-dark btn-block btn-sm" to={`/subtipos-de-contenido/editar/${content.id}`}>
          Editar
        </Link>
      </td>
    </tr>
  );
};

const ContentTable = (
  { contentsSubtypes, pages, onPageChange }:
  { contentsSubtypes: any[], pages: number, onPageChange: any }
) => (
  <div>
    <Pagination pages={pages} onPageChange={onPageChange} />
    <table className="table table-bordered">
      <thead className="table-dark">
        <tr>
          <th>ID</th>
          <th>Nombre</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        {contentsSubtypes.map(ContentRow)}
      </tbody>
    </table>
    <Pagination pages={pages} onPageChange={onPageChange} />
  </div>
);

const ContentList = (
  { contentsSubtypes, pages, onPageChange }:
  { contentsSubtypes: any[], pages: number, onPageChange: any }
) => {
  return (
    <div className="card mb-5">
      <div className="card-header bg-primary text-white">
        <h3 className="mb-0">
          <i className="fa fa-file-text-o"></i> Subtipos de contenido
          <Link className="btn btn-light pull-right" to="/subtipos-de-contenido/crear">
            <i className="fa fa-plus-circle"></i> Crear
          </Link>
        </h3>
      </div>
      <div className="card-body">
        {
          !contentsSubtypes || !contentsSubtypes.length
          ? <NoRecords />
          : <ContentTable {...{ contentsSubtypes, pages, onPageChange }}/>
        }
      </div>
    </div>
  );
}

export default ContentList;



// WEBPACK FOOTER //
// ./src/components/ContentSubtype/list.tsx